import { Status } from 'types/Status';

const AwsStatuses: { [key: string]: Status } = {
    CREATE_COMPLETE: {
        tag: 'Successful creation',
        status: 'success',
        description: 'Successful creation of one or more stacks',
    },
    UPDATE_COMPLETE: {
        tag: 'Update completed',
        status: 'success',
        description: 'Successful update of one or more stacks',
    },
    DELETE_COMPLETE: {
        tag: 'Delete completed',
        status: 'success',
        description:
            'Successful deletion of one or more stacks. Deleted stacks are retained and viewable for 90 days',
    },
    ROLLBACK_COMPLETE: {
        tag: 'Rollback completed',
        status: 'success',
    },
    UPDATE_ROLLBACK_COMPLETE: {
        tag: 'Rollback completed',
        status: 'success',
        description:
            'Successful removal of one or more stacks after a failed stack creation or after an explicitly canceled stack creation. The stack returns to the previous working state. Any resources that were created during the create stack operation are deleted. This status exists only after a failed stack creation. It signifies that all operations from the partially created stack have been appropriately cleaned up. When in this state, only a delete operation can be performed',
    },
    UPDATE_COMPLETE_CLEANUP_IN_PROGRESS: {
        tag: 'Cleanup in progress',
        status: 'warning',
        description:
            'Ongoing removal of old resources for one or more stacks after a successful stack update. For stack updates that require resources to be replaced, CloudFormation creates the new resources first and then deletes the old resources to help reduce any interruptions with your stack. In this state, the stack has been updated and is usable, but CloudFormation is still deleting the old resources',
        progress: true,
    },
    UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS: {
        tag: 'Clean up in progress',
        status: 'warning',
        description:
            'Ongoing removal of new resources for one or more stacks after a failed stack update. In this state, the stack has been rolled back to its previous working state and is usable, but CloudFormation is still deleting any new resources it created during the stack update',
        progress: true,
    },
    CREATE_IN_PROGRESS: {
        tag: 'Creation in progress',
        status: 'warning',
        description: 'Ongoing creation of one or more stacks.',
        progress: true,
    },
    UPDATE_IN_PROGRESS: {
        tag: 'Update in progress',
        status: 'warning',
        description: 'Ongoing update of one or more stacks',
    },
    DELETE_IN_PROGRESS: {
        tag: 'Deletion in progress',
        status: 'warning',
        description: 'Ongoing removal of one or more stacks',
        progress: true,
    },
    ROLLBACK_IN_PROGRESS: {
        tag: 'Rollback in progress',
        status: 'warning',
        description:
            'Ongoing removal of one or more stacks after a failed stack creation or after an explicitly canceled stack creation',
        progress: true,
    },
    UPDATE_ROLLBACK_IN_PROGRESS: {
        tag: 'Rollback in progress',
        status: 'warning',
        description:
            'Ongoing return of one or more stacks to the previous working state after failed stack update.',
        progress: true,
    },
    REVIEW_IN_PROGRESS: {
        tag: 'Review in progress',
        status: 'warning',
        description: 'Waiting system review of process is in progress.',
        progress: true,
    },
    STARTING: {
        tag: 'Starting',
        status: 'warning',
        description: 'Starting processes for creation / update.',
        progress: true,
    },
    RUNNING: {
        tag: 'Running',
        status: 'warning',
        description: 'Running processes for creation / update.',
        progress: true,
    },

    CREATE_FAILED: {
        tag: 'Creation failed',
        status: 'alert',
        description:
            'Unsuccessful creation of one or more stacks. View the stack events to see any associated error messages. Possible reasons for a failed creation include insufficient permissions to work with all resources in the stack, parameter values rejected by an AWS service, or a timeout during resource creation',
    },
    UPDATE_FAILED: {
        tag: 'Update failed',
        status: 'alert',
        description:
            'Unsuccessful update of one or more stacks. View the stack events to see any associated error messages',
    },
    DELETE_FAILED: {
        tag: 'Deletion failed',
        status: 'alert',
        description:
            'Unsuccessful deletion of one or more stacks. Because the delete failed, you might have some resources that are still running; however, you cannot work with or update the stack. Delete the stack again or view the stack events to see any associated error messages',
    },
    ROLLBACK_FAILED: {
        tag: 'Rollback failed',
        status: 'alert',
        description:
            'Unsuccessful removal of one or more stacks after a failed stack creation or after an explicitly canceled stack creation. Delete the stack or view the stack events to see any associated error messages',
    },
    UPDATE_ROLLBACK_FAILED: {
        tag: 'Rollback failed',
        status: 'alert',
        description:
            'Unsuccessful return of one or more stacks to a previous working state after a failed stack update. When in this state, you can delete the stack or continue rollback. You might need to fix errors before your stack can return to a working state. Or, you can contact AWS Support to restore the stack to a usable state',
    },
    ProcessFailed: {
        tag: 'Process failed',
        status: 'alert',
        description:
            'Something went wrong, expecting that the creation / update will pick up and continue.',
    },
    Pending: {
        tag: 'Pending',
        status: 'warning',
        progress: true,
    },
    Failed: {
        tag: 'Failed',
        status: 'alert',
        description:
            'PermissionError: You dont have permissions to create file system.',
    },
    InService: {
        tag: 'Active',
        status: 'success',
        description: 'The domain is active and ready to be used',
    },
};

export default AwsStatuses;
